var map = {
	"./burger_icon.svg": 527,
	"./camp.svg": 1088,
	"./creative.svg": 1089,
	"./cross.svg": 528,
	"./earth_group.svg": 1090,
	"./feature_1.svg": 1091,
	"./feature_2.png": 552,
	"./feature_2.svg": 1092,
	"./feature_3.svg": 1093,
	"./flag.svg": 923,
	"./frontend.svg": 1094,
	"./gamedesign.svg": 1095,
	"./graphicdesign.svg": 1096,
	"./junior.svg": 1097,
	"./map_yellow.svg": 922,
	"./math_circles_bg.svg": 1098,
	"./math_circles_bg_sm.svg": 1099,
	"./math_courses_1.svg": 1100,
	"./math_courses_2.svg": 1101,
	"./math_road_line_1.svg": 1102,
	"./math_road_line_2.svg": 1103,
	"./math_road_line_3.svg": 1104,
	"./math_road_line_4.svg": 1105,
	"./maths_logo.svg": 1106,
	"./maths_logo_white.svg": 1107,
	"./pc.svg": 1108,
	"./programming_bg.svg": 1109,
	"./programming_bg_sm.svg": 1110,
	"./programming_comment_1.svg": 588,
	"./programming_comment_2.svg": 589,
	"./programming_comment_3.svg": 590,
	"./programming_logo-en.svg": 586,
	"./programming_logo-ru.svg": 585,
	"./programming_logo_white.svg": 584,
	"./programming_puzzles.svg": 583,
	"./programming_square.svg": 926,
	"./programming_summer.svg": 1111,
	"./pytpro.svg": 1112,
	"./pytstart.svg": 1113,
	"./school.svg": 924,
	"./share_icon_violet.svg": 927,
	"./share_icon_white.svg": 591,
	"./smile.svg": 925,
	"./tg_logo.svg": 526,
	"./tg_logo_white.svg": 530,
	"./unity.svg": 1114,
	"./videocontent.svg": 1115,
	"./websites.svg": 1116,
	"./whats_logo.svg": 525,
	"./whats_logo_white.svg": 529
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1087;